// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "gg.indi",
    name: "IndiGG",
    homepage: "https://indi.gg",
    image_id: "8e90a32f-130d-4317-7294-4884510aa300",
    app: {
        browser: "https://indi.gg/",
        ios: null,
        android: "https://play.google.com/store/apps/details?id=com.indiggcommunity&hl=en_US",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "indigg://walletconnect",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map